import { useMemo } from 'react';
import { applyClaimedItemIds, claimedItemIdsFromInvoices } from '../utils/claimedLines';
import type { AgreementInvoice, SoldLines } from '../types/agreements.types';

/** Any item id present in a submitted invoice renders claimed. Memoised on
 *  both inputs, and a no-op overlay returns the same lines reference. */
export function useReconciledSoldLines(
    lines: SoldLines | undefined,
    invoices: AgreementInvoice[] | undefined,
): SoldLines | undefined {
    return useMemo(() => {
        if (!lines) return lines;
        return applyClaimedItemIds(lines, claimedItemIdsFromInvoices(invoices ?? []));
    }, [lines, invoices]);
}
